export default __webpack_public_path__ + "static/media/box.558fc842.svg";